export default function AMElephant() {
  return (
      <div>
          <h1>AMElephant</h1>
          <p>AMElephant page content</p>
      </div>
  );
}